!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = t || self, t.kgStatPush = e());
}(this, function () {
  "use strict";

  function t(e) {
    return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(e);
  }

  function e(t, e) {
    switch (e) {
      case !0:
      case 1:
        window.apmCollectData.push([12, t, null, !0]);
        break;

      case 2:
        window.apmCollectData.push([30050, t, null, !1]);
        break;

      case 3:
        window.apmCollectData.push([30030, t, null, !1]);
        break;

      default:
        window.apmCollectData.push([30050, t, null, !1]);
    }

    try {
      window.newLogCount();
    } catch (t) {}
  }

  var n = {
    ver: "2.4",
    isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
    isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
    chkAndroidApp: function chkAndroidApp() {
      try {
        if (external.superCall(122)) return !0;
      } catch (t) {
        return !1;
      }
    },
    cbNum: 0,
    isInClient: function isInClient() {
      var t = this;
      return t.chkAndroidApp() ? t.chkAndroidApp() : !!t.isIOS && t.isIOS;
    },
    str2Json: function str2Json(t) {
      var e = {};
      if ("[object String]" === Object.prototype.toString.call(t)) try {
        e = JSON.parse(t);
      } catch (t) {
        e = {};
      }
      return e;
    },
    json2Str: function json2Str(t) {
      var e = "";
      if ("string" != typeof t) try {
        e = JSON.stringify(t);
      } catch (t) {
        e = "";
      }
      return e;
    },
    loadUrl: function loadUrl(t) {
      var e;
      (e = document.createElement("iframe")).setAttribute("src", t), e.setAttribute("style", "display:none;"), e.setAttribute("height", "0px"), e.setAttribute("width", "0px"), e.setAttribute("frameborder", "0"), document.body.appendChild(e), e.parentNode.removeChild(e), e = null;
    },
    callCmd: function callCmd(t) {
      var e,
          n = this,
          i = "",
          r = "";
      if (n.chkAndroidApp()) try {
        e = t.jsonStr ? external.superCall(t.cmd, t.jsonStr) : external.superCall(t.cmd), t.callback && "" !== t.callback && (e = n.str2Json(e), t.callback(e));
      } catch (t) {} else n.isIOS ? (t.callback ? (i = "kgmobilecalllite" + ++n.cbNum + Math.random().toString().substr(2, 9), window[i] = function (e) {
        void 0 !== e && t.callback && ("[object String]" === Object.prototype.toString.call(e) ? t.callback(n.str2Json(e)) : t.callback(e));
      }, r = t.jsonStr ? 'kugouurl://start.music/?{"cmd":' + t.cmd + ', "jsonStr":' + t.jsonStr + ', "callback":"' + i + '"}' : 'kugouurl://start.music/?{"cmd":' + t.cmd + ', "callback":"' + i + '"}') : r = t.jsonStr ? 'kugouurl://start.music/?{"cmd":' + t.cmd + ', "jsonStr":' + t.jsonStr + "}" : 'kugouurl://start.music/?{"cmd":' + t.cmd + "}", n.loadUrl(r)) : t.callback && t.callback({
        status: 0,
        error: "不在客户端内"
      });
    },
    getData: function getData(t, e) {
      var n = this,
          i = "";
      t && (i = n.json2Str(t), e ? n.callCmd({
        cmd: 186,
        jsonStr: i,
        callback: e,
        AndroidCallback: !0
      }) : n.callCmd({
        cmd: 186,
        jsonStr: i
      }));
    }
  },
      i = i || {
    appid: 1e3,
    appkey: "abcdefg"
  };
  return function () {
    function e() {
      var t = {
        _t: new Date().getTime(),
        _r: Math.random(),
        appid: i.appid
      },
          e = l(t, ""),
          n = "https://webcollects.kugou.com/v2/web/time.js?appid=" + t.appid + "&_t=" + t._t + "&_r=" + t._r + "&sign=" + e;

      try {
        a(n, i.callback);
      } catch (t) {}

      clearTimeout(i.callbackT), i.callbackT = setTimeout(function () {
        if (1 != i.getServerFlag && i.requestList.length > 0) {
          for (var t = 0, e = i.requestList.length; t < e; t++) {
            var n = i.requestList[t];
            n[2] && n[2]();
          }

          clearTimeout(i.callbackT);
        }
      }, 2e3);
    }

    function r(t, e, n, r) {
      var o = {
        _t: c(),
        business: t,
        appid: i.appid
      },
          a = l(o, e),
          h = "https://webcollects.kugou.com/";
      r && (h = "https://rtwebcollects.kugou.com/"), s(h + "v2/web/post?appid=" + o.appid + "&business=" + o.business + "&_t=" + o._t + "&sign=" + a, e, n);
    }

    function o(e, n) {
      var i,
          r,
          a,
          s,
          c,
          l = {
        "\b": "\\b",
        "\t": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
      },
          h = /["\\\x00-\x1f\x7f-\x9f]/g;

      switch (t(e)) {
        case "string":
          return h.test(e) ? '"' + e.replace(h, function (t) {
            var e = l[t];
            return e || (e = t.charCodeAt(), "\\u00" + Math.floor(e / 16).toString(16) + (e % 16).toString(16));
          }) + '"' : '"' + e + '"';

        case "number":
          return isFinite(e) ? String(e) : "null";

        case "boolean":
        case "null":
          return String(e);

        case "object":
          if (!e) return "null";
          if ("function" == typeof e.toJSON) return o(e.toJSON());

          if (i = [], "number" == typeof e.length && !e.propertyIsEnumerable("length")) {
            for (s = e.length, r = 0; r < s; r += 1) {
              i.push(o(e[r], n) || "null");
            }

            return "[" + i.join(",") + "]";
          }

          if (n) for (s = n.length, r = 0; r < s; r += 1) {
            "string" == typeof (a = n[r]) && (c = o(e[a], n)) && i.push(o(a) + ":" + c);
          } else for (a in e) {
            "string" == typeof a && (c = o(e[a], n)) && i.push(o(a) + ":" + c);
          }
          return "{" + i.join(",") + "}";
      }
    }

    function a(t, e) {
      if (n.isInClient()) {
        var i = {
          url: t,
          method: "get",
          timeout: 0,
          param: ""
        };
        setTimeout(function () {
          return n.getData(i, function (t) {
            e && e(t);
          }), null;
        }, 30);
      } else {
        var r = new XMLHttpRequest();
        r.onreadystatechange = function () {
          4 !== r.readyState || 200 !== r.status && 304 !== r.status || e(r.responseText);
        }, r.open("GET", t, !0), r.send();
      }
    }

    function s(t, e, r, o) {
      if (n.isInClient()) {
        var a = p(),
            s = document.createElement("form");
        s.name = "postForm" + a, s.id = "postForm" + a;
        var c = document.createElement("input");
        c.type = "hidden", c.name = "content", c.value = e, s.appendChild(c), document.body.appendChild(s);
        var l = null;

        try {
          l = document.createElement('<iframe name="postIframe' + a + '">');
        } catch (t) {
          l = document.createElement("iframe");
        }

        try {
          l.name = "postIframe" + a, l.id = "postIframe" + a, l.width = "1", l.height = "1", l.style.display = "none", document.body.appendChild(l), s.action = t, s.target = l.name, s.method = "post", s.submit(), r && r();
        } catch (t) {
          r && r();
        }

        return l.attachEvent ? l.attachEvent("onload", function () {
          void 0 != i.clinetfrom && "1001" != i.clinetfrom || (document.body.removeChild(l), document.body.removeChild(s)), l = null, r && r();
        }) : l.onload = function () {
          void 0 != i.clinetfrom && "1001" != i.clinetfrom || (document.body.removeChild(l), document.body.removeChild(s)), l = null, r && r();
        }, !1;
      }

      var h = new XMLHttpRequest();
      return h.open("POST", t, !0), h.withCredentials = !0, h.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), h.onreadystatechange = function () {
        4 == h.readyState && r && r();
      }, h.send("content=" + encodeURIComponent(e)), !1;
    }

    function c() {
      return parseInt(new Date().getTime() / 1e3) + i.jetTag;
    }

    function l(t, e) {
      var n = "",
          r = [];

      for (var o in t) {
        r.push(o);
      }

      r.sort();

      for (var a = 0, s = r.length; a < s; a++) {
        n += r[a] + t[r[a]];
      }

      return n += i.appkey + e, d.md5(n);
    }

    function h(t) {
      for (var e in t) {
        if (t.hasOwnProperty(e)) return !1;
      }

      return !0;
    }

    function u(t, n, a, s) {
      try {
        if (apmCollectData && apmCollectData.length > 0) for (var c = 0, l = apmCollectData.length; c < l; c++) {
          var d = apmCollectData.pop(),
              p = d[1];
          u(d[0], p, d[2], d[3]);
        }
      } catch (t) {}

      try {
        n.toString(), i.clinetfrom = n.plat_id;
      } catch (t) {}

      if (!h(n)) {
        var m = encodeURIComponent(o(n)),
            g = [t, n, a, s];
        i.getServerFlag ? r(t, m, a, s) : (i.requestList.push(g), clearTimeout(f), f = setTimeout(e, 1e3));
      }
    }

    if (1 != i.loaded) {
      i.loaded = !0;
      var f;
      i.servertime = 1421395624, i.getServerFlag = !1, i.requestList = [], i.jetTag = -1, i.callback = function (t) {
        i.getServerFlag = !0;
        var e = parseInt(t.now);
        if (i.servertime = parseInt(e), i.jetTag = i.servertime - parseInt(new Date().getTime() / 1e3) || 0, i.getServerFlag && (clearTimeout(f), i.requestList.length > 0)) for (var n = 0, a = i.requestList.length; n < a; n++) {
          var s = i.requestList.pop(),
              c = encodeURIComponent(o(s[1]));
          r(s[0], c, s[2], s[3]);
        }
      };

      var d = {
        hex_chr: "0123456789abcdef",
        rhex: function rhex(t) {
          for (var e = "", n = 0; n <= 3; n++) {
            e += this.hex_chr.charAt(t >> 8 * n + 4 & 15) + this.hex_chr.charAt(t >> 8 * n & 15);
          }

          return e;
        },
        str2blks_MD5: function str2blks_MD5(t) {
          for (var e = 1 + (t.length + 8 >> 6), n = new Array(16 * e), i = 0; i < 16 * e; i++) {
            n[i] = 0;
          }

          for (i = 0; i < t.length; i++) {
            n[i >> 2] |= t.charCodeAt(i) << i % 4 * 8;
          }

          return n[i >> 2] |= 128 << i % 4 * 8, n[16 * e - 2] = 8 * t.length, n;
        },
        add: function add(t, e) {
          var n = (65535 & t) + (65535 & e);
          return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
        },
        rol: function rol(t, e) {
          return t << e | t >>> 32 - e;
        },
        cmn: function cmn(t, e, n, i, r, o) {
          return this.add(this.rol(this.add(this.add(e, t), this.add(i, o)), r), n);
        },
        ff: function ff(t, e, n, i, r, o, a) {
          return this.cmn(e & n | ~e & i, t, e, r, o, a);
        },
        gg: function gg(t, e, n, i, r, o, a) {
          return this.cmn(e & i | n & ~i, t, e, r, o, a);
        },
        hh: function hh(t, e, n, i, r, o, a) {
          return this.cmn(e ^ n ^ i, t, e, r, o, a);
        },
        ii: function ii(t, e, n, i, r, o, a) {
          return this.cmn(n ^ (e | ~i), t, e, r, o, a);
        },
        md5: function md5(t) {
          for (var e = this.str2blks_MD5(t), n = 1732584193, i = -271733879, r = -1732584194, o = 271733878, a = 0; a < e.length; a += 16) {
            var s = n,
                c = i,
                l = r,
                h = o;
            n = this.ff(n, i, r, o, e[a + 0], 7, -680876936), o = this.ff(o, n, i, r, e[a + 1], 12, -389564586), r = this.ff(r, o, n, i, e[a + 2], 17, 606105819), i = this.ff(i, r, o, n, e[a + 3], 22, -1044525330), n = this.ff(n, i, r, o, e[a + 4], 7, -176418897), o = this.ff(o, n, i, r, e[a + 5], 12, 1200080426), r = this.ff(r, o, n, i, e[a + 6], 17, -1473231341), i = this.ff(i, r, o, n, e[a + 7], 22, -45705983), n = this.ff(n, i, r, o, e[a + 8], 7, 1770035416), o = this.ff(o, n, i, r, e[a + 9], 12, -1958414417), r = this.ff(r, o, n, i, e[a + 10], 17, -42063), i = this.ff(i, r, o, n, e[a + 11], 22, -1990404162), n = this.ff(n, i, r, o, e[a + 12], 7, 1804603682), o = this.ff(o, n, i, r, e[a + 13], 12, -40341101), r = this.ff(r, o, n, i, e[a + 14], 17, -1502002290), i = this.ff(i, r, o, n, e[a + 15], 22, 1236535329), n = this.gg(n, i, r, o, e[a + 1], 5, -165796510), o = this.gg(o, n, i, r, e[a + 6], 9, -1069501632), r = this.gg(r, o, n, i, e[a + 11], 14, 643717713), i = this.gg(i, r, o, n, e[a + 0], 20, -373897302), n = this.gg(n, i, r, o, e[a + 5], 5, -701558691), o = this.gg(o, n, i, r, e[a + 10], 9, 38016083), r = this.gg(r, o, n, i, e[a + 15], 14, -660478335), i = this.gg(i, r, o, n, e[a + 4], 20, -405537848), n = this.gg(n, i, r, o, e[a + 9], 5, 568446438), o = this.gg(o, n, i, r, e[a + 14], 9, -1019803690), r = this.gg(r, o, n, i, e[a + 3], 14, -187363961), i = this.gg(i, r, o, n, e[a + 8], 20, 1163531501), n = this.gg(n, i, r, o, e[a + 13], 5, -1444681467), o = this.gg(o, n, i, r, e[a + 2], 9, -51403784), r = this.gg(r, o, n, i, e[a + 7], 14, 1735328473), i = this.gg(i, r, o, n, e[a + 12], 20, -1926607734), n = this.hh(n, i, r, o, e[a + 5], 4, -378558), o = this.hh(o, n, i, r, e[a + 8], 11, -2022574463), r = this.hh(r, o, n, i, e[a + 11], 16, 1839030562), i = this.hh(i, r, o, n, e[a + 14], 23, -35309556), n = this.hh(n, i, r, o, e[a + 1], 4, -1530992060), o = this.hh(o, n, i, r, e[a + 4], 11, 1272893353), r = this.hh(r, o, n, i, e[a + 7], 16, -155497632), i = this.hh(i, r, o, n, e[a + 10], 23, -1094730640), n = this.hh(n, i, r, o, e[a + 13], 4, 681279174), o = this.hh(o, n, i, r, e[a + 0], 11, -358537222), r = this.hh(r, o, n, i, e[a + 3], 16, -722521979), i = this.hh(i, r, o, n, e[a + 6], 23, 76029189), n = this.hh(n, i, r, o, e[a + 9], 4, -640364487), o = this.hh(o, n, i, r, e[a + 12], 11, -421815835), r = this.hh(r, o, n, i, e[a + 15], 16, 530742520), i = this.hh(i, r, o, n, e[a + 2], 23, -995338651), n = this.ii(n, i, r, o, e[a + 0], 6, -198630844), o = this.ii(o, n, i, r, e[a + 7], 10, 1126891415), r = this.ii(r, o, n, i, e[a + 14], 15, -1416354905), i = this.ii(i, r, o, n, e[a + 5], 21, -57434055), n = this.ii(n, i, r, o, e[a + 12], 6, 1700485571), o = this.ii(o, n, i, r, e[a + 3], 10, -1894986606), r = this.ii(r, o, n, i, e[a + 10], 15, -1051523), i = this.ii(i, r, o, n, e[a + 1], 21, -2054922799), n = this.ii(n, i, r, o, e[a + 8], 6, 1873313359), o = this.ii(o, n, i, r, e[a + 15], 10, -30611744), r = this.ii(r, o, n, i, e[a + 6], 15, -1560198380), i = this.ii(i, r, o, n, e[a + 13], 21, 1309151649), n = this.ii(n, i, r, o, e[a + 4], 6, -145523070), o = this.ii(o, n, i, r, e[a + 11], 10, -1120210379), r = this.ii(r, o, n, i, e[a + 2], 15, 718787259), i = this.ii(i, r, o, n, e[a + 9], 21, -343485551), n = this.add(n, s), i = this.add(i, c), r = this.add(r, l), o = this.add(o, h);
          }

          return this.rhex(n) + this.rhex(i) + this.rhex(r) + this.rhex(o);
        }
      },
          p = function () {
        var t = new Date().getTime() + "-",
            e = 0;
        return function () {
          return t + e++;
        };
      }();

      e();

      try {
        if (apmCollectData && apmCollectData.length > 0) for (var m = 0, g = apmCollectData.length; m < g; m++) {
          var b = apmCollectData.pop(),
              v = b[1];
          u(b[0], v, b[2], b[3]);
        }
      } catch (t) {}

      window.newLogCount = u;
    }
  }(), function (t) {
    "function" == typeof define && define(t);
  }(function (t, e, n) {
    n.exports = newLogCount;
  }), window.apmCollectData = [], window.WebCollectConfig = i, e;
});